import {ScrollTrigger} from "../LibrariesImport";

export default class BlockTextSliderImages {
    static init() {
        let sliders = document.querySelectorAll('.block-text-slider-images .slider-images');
        sliders.forEach((slider) => {
            this.slider(slider);
        });
    }

    static slider(slider) {
        let swiper = new Swiper(slider, {
            allowTouchMove: ScrollTrigger.isTouch,
            speed: 500,
            navigation: {
                nextEl: slider.querySelector('.slider-images-nav .next'),
                prevEl: slider.querySelector('.slider-images-nav .prev'),
            },
            pagination: {
                el: slider.querySelector('.slider-images-nav .pagination'),
                type: 'bullets',
            },

        });


    }
}
